import Vue from 'vue'
import MijnAccount from '../vue/MijnAccount.vue'

export default {
  init() {
    new Vue({
      el: '#app',
      components: {
        MijnAccount,
      },
    })
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/mijnAccount.js